let _ = t => t,
  _t;
import _styled from "styled-components";
import { getQuickReplies, getTextTypeReplies, getURLTypeReplies } from './operators/quickRepliesAttachmentGetters';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error module not typed
import PrimaryMessageContentSection from '../primary-message/components/PrimaryMessageContentSection';
import { Small } from 'foundations-components/transitional/components/Small';
import { Link } from 'foundations-components/transitional/components/Link';
import get from 'transmute/get';
import { H7 } from 'foundations-components/transitional/components/H7';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const QuickRepliesAttachment = ({
  quickRepliesAttachment
}) => {
  const quickReplies = getQuickReplies(quickRepliesAttachment);
  const urlTypeReplies = getURLTypeReplies(quickReplies);
  const textTypeReplies = getTextTypeReplies(quickReplies);
  return /*#__PURE__*/_jsxs(PrimaryMessageContentSection, {
    children: [urlTypeReplies && urlTypeReplies.size > 0 && /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-message-history.common-message.attachmentRendering.quickReplies.sentButtonLinks"
          })
        }), urlTypeReplies && urlTypeReplies.toArray().map(elem => /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(Link, {
            external: true,
            href: get('value', elem),
            children: get('label', elem)
          })
        }, get('label', elem)))]
      })
    }), textTypeReplies && textTypeReplies.size > 0 && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-message-history.common-message.attachmentRendering.quickReplies.sentQuickReplyOptions"
        })
      }), /*#__PURE__*/_jsx(_StyledUl, {
        children: textTypeReplies && textTypeReplies.toArray().map(elem => /*#__PURE__*/_jsx("li", {
          children: /*#__PURE__*/_jsx(H7, {
            marginBlockEnd: "200",
            children: get('label', elem)
          })
        }, get('label', elem)))
      })]
    })]
  });
};
QuickRepliesAttachment.displayName = 'QuickRepliesAttachment';
export default QuickRepliesAttachment;
var _StyledUl = _styled("ul")(_t || (_t = _`
              padding-inline-start: 20px;
            `));